export enum OrigemLancamentosEnum {

    API = 'API'
    // CSV = "CSV"

  }
